import React, {useEffect, useState} from "react";
import localization from "assets/localization/localization";
import '../../main.css'
import Layout from 'components/sales/layout/layout';
import CustomModal from "../../modal";
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";

const SaveTag = ({
                     createTag,
                     tagCreation = []
                 }) => {

    const [count, setCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{
        project_id: '', count: ''
    }]);
    const [projectIdValidation, setProjectIdValidation] = useState("")
    const [countValidation, setCountValidation] = useState("")

    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
    };

    const handleOnSubmitForm = async () => {
        let inputValues = inputList[0]
        setProjectIdValidation("")
        setCountValidation("")
        if (inputValues.project_id === "") {
            setProjectIdValidation("Project id is required")
            return false
        }

        if (inputValues.count === "") {
            setProjectIdValidation("Tag count is required")
            return false
        }

        if (inputValues.count <= 0 || inputValues.count > 500) {
            setProjectIdValidation("Tag count must between 1 or 500")
            return false
        }

        if (inputValues.project_id !== '') {
            setIsLoading(true)
            await createTag(inputValues);
            setIsLoading(false)
            setCount(count + 1)
        }
    }

    return (
        <>
            <Layout title={localization.tagCount}
                    isGoback
                    isLoading={isLoading}
            >
                <div className="container-fluid">
                    <div className="card">
                        {tagCreation !== null && tagCreation?.response?.status !== 200 &&
                            <CustomModal msg={tagCreation?.response?.message} click={count}/>}
                        {tagCreation !== null && tagCreation?.response?.status === 200 &&
                            <CustomModal msg={tagCreation?.response?.message} isPageLoad={true} click={count}/>}
                        <div className="card-header">
                            {localization.tagCount}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="validation">{projectIdValidation}</div>
                                    <div className="col-md-4">
                                        <ConstantInput
                                            label={localization.projectId}
                                            type="text"
                                            handleChange={(val) => {
                                                handleInputValue(val, 'project_id');
                                            }}
                                            required
                                            isStarRequired={true}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <div className="validation">{countValidation}</div>
                                        <ConstantInput
                                            label={localization.tagCount}
                                            type="text"
                                            handleChange={(val) => {
                                                handleInputValue(val, 'count');
                                            }}
                                            required
                                            isStarRequired={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <center><Button onClick={handleOnSubmitForm}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default SaveTag